import { NavLink as RouterLink, useLocation, useNavigate } from 'react-router-dom'
import { Box, Link, Typography, useMediaQuery } from '@mui/material'
import { styled, useTheme } from '@mui/material/styles'
import Btn from '../components/Btn'
import logo from '../assets/images/logo-lg.svg'
import { PATH_LOGIN } from '../routes/constant'
import { usePostForgotPasswordMutation } from '../redux/api/userApi'
import ErrorMessage from '../components/ErrorMessage'

const PageLink = styled(Link)(({ theme }) => ({
  color: theme.palette.secondary.main,
  margin: 0
}))

const PageText = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[65],
  fontWeight: 500,
  lineHeight: '16.5px',
  marginBottom: '34px',
  [theme.breakpoints.down('lg')]: {
    textAlign: 'center'
  }
}))

const PasswordSentPage: React.FC = () => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'))
  const navigate = useNavigate()
  const location = useLocation()
  const [forgotPassword, { error }] = usePostForgotPasswordMutation()

  const onResend = async () => {
    const email = location?.state?.email
    const xsrf = location?.state?.xsrf
    if (email && xsrf) {
      await forgotPassword({ email, xsrf })
    } else {
      navigate(PATH_LOGIN.PASSWORD_RESET, { replace: true })
    }
  }

  return (
        <Box>
            <Box
                component='img'
                src={logo}
                sx={{
                  display: isMobile ? 'block' : 'none',
                  height: '70px',
                  margin: '0 auto 50px',
                  width: '189px'
                }}
            />
            <Typography sx={{
              color: '#000',
              fontSize: 24,
              mb: '27px',
              textAlign: isMobile ? 'center' : 'left'
            }} variant='h2'>Password Reset Sent!</Typography>
            <PageText variant='h6'>
                We`ve sent you an email containing further instructions for resetting your password.
            </PageText>
            <PageText variant='h6'>
                If you haven`t received an email in 5 minutes, check your spam, <PageLink onClick={onResend}
                underline="none">resend</PageLink>, or <PageLink onClick={() => {
                  navigate(PATH_LOGIN.PASSWORD_RESET, { replace: true })
                }} underline="none">try a different email</PageLink>.
            </PageText>
            <Box sx={{
              display: 'flex',
              justifyContent: 'center',
              m: '26px 0 0'
            }}>
                <Btn
                    component={RouterLink} to={PATH_LOGIN.LOGIN}
                    variant='contained'
                    color='secondary'
                    text='Back to Sign In'
                    type='submit'
                    sx={{
                      cursor: 'pointer',
                      fontSize: '14px',
                      p: '18px 0 ',
                      width: '100%'
                    }}
                />
            </Box>
            <ErrorMessage error={error} />
        </Box>
  )
}

export default PasswordSentPage
